import Modal, { ModalOwnProps } from '@mui/material/Modal'

export interface IBaseModalProps extends ModalOwnProps {
  close: () => void
}

/**
 * MUI modal wrapper with some unified baseline behaviour
 * - backdrop click to close functionality disabled
 *
 * Interface is like that of MUI Modal but with a few additional
 * props (see `IBaseModalProps`)
 */
const BaseModal = ({ close, ...props }: IBaseModalProps) => {
  const closeModal = (
    _evt?: object,
    reason?: 'backdropClick' | 'escapeKeyDown'
  ) => {
    if (reason === 'backdropClick') {
      return
    }

    close()
  }

  return (
    <Modal {...props} onClose={closeModal}>
      {props.children}
    </Modal>
  )
}

export default BaseModal
